import { defineComponent as _defineComponent } from 'vue'
import {
  EProductTypes,
  getProductCategoriesFilters,
  getProductPerformancePrePurchase,
  IProductBenchmark,
  IProductPerformanceResponse,
  IProductPeriod
} from '@/modules/catalog/services/products';
import { PropType, computed, onMounted, ref } from 'vue';
import {
  LineChart,
  ChartFooterV2
} from '@/modules/common/components/charts/v2';
import { HelperViewStatus } from '@warrenbrasil/nebraska-web';
import ProductPerformanceHeader from './components/ProductPerformanceHeader.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductPerformance',
  props: {
  categorySelectedProduct: {
    type: String as PropType<EProductTypes>,
    default: EProductTypes.FUNDS
  },
  productApiId: {
    type: String,
    default: ''
  }
},
  setup(__props) {

const props = __props;



const productPerformance = ref<IProductPerformanceResponse>();
const benchmarkFilters = ref<IProductBenchmark[]>([]);
const periodFilters = ref<IProductPeriod[]>([]);
const isLoading = ref(false);
const error = ref(false);

const productPerformanceSeries = computed(() => {
  const asset = productPerformance.value?.chart.axisY?.find(
    axis => axis.type === 'Asset'
  );

  return {
    name: asset?.name || '-',
    data: asset?.values.map(item => item?.value) || [],
    comparator: [],
    benchmarkComparison: []
  };
});

const labels = computed(
  () =>
    productPerformance.value?.chart.axisX?.[0]?.values?.map(
      value => value.value
    ) || []
);

const benchmarkData = computed(() => {
  const benchmark = productPerformance.value?.chart.axisY?.find(
    axis => axis.type === 'index'
  );

  return {
    name: benchmark?.name || '-',
    data: benchmark?.values.map(item => item?.value) || []
  };
});

const fetchProductPerformance = async () => {
  isLoading.value = true;
  try {
    const response = await getProductPerformancePrePurchase(
      props.productApiId,
      props.categorySelectedProduct,
      periodFilters.value.find(filter => filter.active)?.value || '',
      benchmarkFilters.value.find(filter => filter.active)?.value || ''
    );
    productPerformance.value = response;
    error.value = false;
  } catch {
    error.value = true;
  } finally {
    isLoading.value = false;
  }
};

async function fetchProductCategoriesFilters() {
  isLoading.value = true;
  try {
    const response = await getProductCategoriesFilters(
      props.categorySelectedProduct
    );
    benchmarkFilters.value = response.benchmarks;
    periodFilters.value = response.periods;
    error.value = false;
  } catch {
    error.value = true;
  } finally {
    isLoading.value = false;
  }
}

const handlePeriodFilterChange = (value: string) => {
  periodFilters.value = periodFilters.value.map(filter => ({
    ...filter,
    active: filter.value === value
  }));
  fetchProductPerformance();
};

const handleBenchmarkFilterChange = (value: string) => {
  benchmarkFilters.value = benchmarkFilters.value.map(filter => ({
    ...filter,
    active: filter.value === value
  }));
  fetchProductPerformance();
};

const fetchProductPerformanceAndFilters = async () => {
  await fetchProductCategoriesFilters();
  await fetchProductPerformance();
};

onMounted(fetchProductPerformanceAndFilters);

return { __sfc: true,props, productPerformance, benchmarkFilters, periodFilters, isLoading, error, productPerformanceSeries, labels, benchmarkData, fetchProductPerformance, fetchProductCategoriesFilters, handlePeriodFilterChange, handleBenchmarkFilterChange, fetchProductPerformanceAndFilters, LineChart, ChartFooterV2, HelperViewStatus, ProductPerformanceHeader }
}

})